import(/* webpackMode: "eager" */ "/app/app/explorer/wallets/page.tsx");
